

const PriceTable = {
  GBP: { symbol: '&pound;',  base: 1300, page: 31, ship: 500, shipFreeLimit: 9000  },
  EUR: { symbol: '&euro;', base: 1500, page: 35, ship: 750, shipFreeLimit: 10000 },
  USD: { symbol: '$',       base: 2000, page: 46, ship: 1000, shipFreeLimit: 12500 },
  //GBP: { symbol: '&pound;',  base: 1300, page: 31, ship: 500, shipFreeLimit: 9000  },
  //EUR: { symbol: '&euro;', base: 1500, page: 35, ship: 600, shipFreeLimit: 10000 },
  //USD: { symbol: '$',       base: 1800, page: 42, ship: 700, shipFreeLimit: 12000 },
}

export default {
  Currencies: PriceTable,
  calculatePrice: function(format, pagecount, currency) {
    const p = PriceTable[currency || 'USD'] 
    if (format == 'a4' || format == 'a4r') {
      return p.base + p.page * Math.max(pagecount, 24)
    }
    return 99900 //!!
  },
  shippingPrice: function(format, pagecount, orderPrice, currency) {
    const p = PriceTable[currency || 'USD'] 
    return orderPrice >= p.shipFreeLimit ? 0 : Math.min(p.ship, p.shipFreeLimit - orderPrice)
  },
  freeShippingThreshold: function(format, currency) {
    const p = PriceTable[currency || 'USD'] 
    return p.shipFreeLimit
  },
}



// WEBPACK FOOTER //
// ./src/pricer.js